/*!
Waypoints - 4.0.1
Copyright © 2011-2016 Caleb Troughton
Licensed under the MIT license.
https://github.com/imakewebthings/waypoints/blob/master/licenses.txt
*/
!function(){"use strict";function t(o){if(!o)throw new Error("No options passed to Waypoint constructor");if(!o.element)throw new Error("No element option passed to Waypoint constructor");if(!o.handler)throw new Error("No handler option passed to Waypoint constructor");this.key="waypoint-"+e,this.options=t.Adapter.extend({},t.defaults,o),this.element=this.options.element,this.adapter=new t.Adapter(this.element),this.callback=o.handler,this.axis=this.options.horizontal?"horizontal":"vertical",this.enabled=this.options.enabled,this.triggerPoint=null,this.group=t.Group.findOrCreate({name:this.options.group,axis:this.axis}),this.context=t.Context.findOrCreateByElement(this.options.context),t.offsetAliases[this.options.offset]&&(this.options.offset=t.offsetAliases[this.options.offset]),this.group.add(this),this.context.add(this),i[this.key]=this,e+=1}var e=0,i={};t.prototype.queueTrigger=function(t){this.group.queueTrigger(this,t)},t.prototype.trigger=function(t){this.enabled&&this.callback&&this.callback.apply(this,t)},t.prototype.destroy=function(){this.context.remove(this),this.group.remove(this),delete i[this.key]},t.prototype.disable=function(){return this.enabled=!1,this},t.prototype.enable=function(){return this.context.refresh(),this.enabled=!0,this},t.prototype.next=function(){return this.group.next(this)},t.prototype.previous=function(){return this.group.previous(this)},t.invokeAll=function(t){var e=[];for(var o in i)e.push(i[o]);for(var n=0,r=e.length;r>n;n++)e[n][t]()},t.destroyAll=function(){t.invokeAll("destroy")},t.disableAll=function(){t.invokeAll("disable")},t.enableAll=function(){t.Context.refreshAll();for(var e in i)i[e].enabled=!0;return this},t.refreshAll=function(){t.Context.refreshAll()},t.viewportHeight=function(){return window.innerHeight||document.documentElement.clientHeight},t.viewportWidth=function(){return document.documentElement.clientWidth},t.adapters=[],t.defaults={context:window,continuous:!0,enabled:!0,group:"default",horizontal:!1,offset:0},t.offsetAliases={"bottom-in-view":function(){return this.context.innerHeight()-this.adapter.outerHeight()},"right-in-view":function(){return this.context.innerWidth()-this.adapter.outerWidth()}},window.Waypoint=t}(),function(){"use strict";function t(t){window.setTimeout(t,1e3/60)}function e(t){this.element=t,this.Adapter=n.Adapter,this.adapter=new this.Adapter(t),this.key="waypoint-context-"+i,this.didScroll=!1,this.didResize=!1,this.oldScroll={x:this.adapter.scrollLeft(),y:this.adapter.scrollTop()},this.waypoints={vertical:{},horizontal:{}},t.waypointContextKey=this.key,o[t.waypointContextKey]=this,i+=1,n.windowContext||(n.windowContext=!0,n.windowContext=new e(window)),this.createThrottledScrollHandler(),this.createThrottledResizeHandler()}var i=0,o={},n=window.Waypoint,r=window.onload;e.prototype.add=function(t){var e=t.options.horizontal?"horizontal":"vertical";this.waypoints[e][t.key]=t,this.refresh()},e.prototype.checkEmpty=function(){var t=this.Adapter.isEmptyObject(this.waypoints.horizontal),e=this.Adapter.isEmptyObject(this.waypoints.vertical),i=this.element==this.element.window;t&&e&&!i&&(this.adapter.off(".waypoints"),delete o[this.key])},e.prototype.createThrottledResizeHandler=function(){function t(){e.handleResize(),e.didResize=!1}var e=this;this.adapter.on("resize.waypoints",function(){e.didResize||(e.didResize=!0,n.requestAnimationFrame(t))})},e.prototype.createThrottledScrollHandler=function(){function t(){e.handleScroll(),e.didScroll=!1}var e=this;this.adapter.on("scroll.waypoints",function(){(!e.didScroll||n.isTouch)&&(e.didScroll=!0,n.requestAnimationFrame(t))})},e.prototype.handleResize=function(){n.Context.refreshAll()},e.prototype.handleScroll=function(){var t={},e={horizontal:{newScroll:this.adapter.scrollLeft(),oldScroll:this.oldScroll.x,forward:"right",backward:"left"},vertical:{newScroll:this.adapter.scrollTop(),oldScroll:this.oldScroll.y,forward:"down",backward:"up"}};for(var i in e){var o=e[i],n=o.newScroll>o.oldScroll,r=n?o.forward:o.backward;for(var s in this.waypoints[i]){var a=this.waypoints[i][s];if(null!==a.triggerPoint){var l=o.oldScroll<a.triggerPoint,h=o.newScroll>=a.triggerPoint,p=l&&h,u=!l&&!h;(p||u)&&(a.queueTrigger(r),t[a.group.id]=a.group)}}}for(var c in t)t[c].flushTriggers();this.oldScroll={x:e.horizontal.newScroll,y:e.vertical.newScroll}},e.prototype.innerHeight=function(){return this.element==this.element.window?n.viewportHeight():this.adapter.innerHeight()},e.prototype.remove=function(t){delete this.waypoints[t.axis][t.key],this.checkEmpty()},e.prototype.innerWidth=function(){return this.element==this.element.window?n.viewportWidth():this.adapter.innerWidth()},e.prototype.destroy=function(){var t=[];for(var e in this.waypoints)for(var i in this.waypoints[e])t.push(this.waypoints[e][i]);for(var o=0,n=t.length;n>o;o++)t[o].destroy()},e.prototype.refresh=function(){var t,e=this.element==this.element.window,i=e?void 0:this.adapter.offset(),o={};this.handleScroll(),t={horizontal:{contextOffset:e?0:i.left,contextScroll:e?0:this.oldScroll.x,contextDimension:this.innerWidth(),oldScroll:this.oldScroll.x,forward:"right",backward:"left",offsetProp:"left"},vertical:{contextOffset:e?0:i.top,contextScroll:e?0:this.oldScroll.y,contextDimension:this.innerHeight(),oldScroll:this.oldScroll.y,forward:"down",backward:"up",offsetProp:"top"}};for(var r in t){var s=t[r];for(var a in this.waypoints[r]){var l,h,p,u,c,d=this.waypoints[r][a],f=d.options.offset,w=d.triggerPoint,y=0,g=null==w;d.element!==d.element.window&&(y=d.adapter.offset()[s.offsetProp]),"function"==typeof f?f=f.apply(d):"string"==typeof f&&(f=parseFloat(f),d.options.offset.indexOf("%")>-1&&(f=Math.ceil(s.contextDimension*f/100))),l=s.contextScroll-s.contextOffset,d.triggerPoint=Math.floor(y+l-f),h=w<s.oldScroll,p=d.triggerPoint>=s.oldScroll,u=h&&p,c=!h&&!p,!g&&u?(d.queueTrigger(s.backward),o[d.group.id]=d.group):!g&&c?(d.queueTrigger(s.forward),o[d.group.id]=d.group):g&&s.oldScroll>=d.triggerPoint&&(d.queueTrigger(s.forward),o[d.group.id]=d.group)}}return n.requestAnimationFrame(function(){for(var t in o)o[t].flushTriggers()}),this},e.findOrCreateByElement=function(t){return e.findByElement(t)||new e(t)},e.refreshAll=function(){for(var t in o)o[t].refresh()},e.findByElement=function(t){return o[t.waypointContextKey]},window.onload=function(){r&&r(),e.refreshAll()},n.requestAnimationFrame=function(e){var i=window.requestAnimationFrame||window.mozRequestAnimationFrame||window.webkitRequestAnimationFrame||t;i.call(window,e)},n.Context=e}(),function(){"use strict";function t(t,e){return t.triggerPoint-e.triggerPoint}function e(t,e){return e.triggerPoint-t.triggerPoint}function i(t){this.name=t.name,this.axis=t.axis,this.id=this.name+"-"+this.axis,this.waypoints=[],this.clearTriggerQueues(),o[this.axis][this.name]=this}var o={vertical:{},horizontal:{}},n=window.Waypoint;i.prototype.add=function(t){this.waypoints.push(t)},i.prototype.clearTriggerQueues=function(){this.triggerQueues={up:[],down:[],left:[],right:[]}},i.prototype.flushTriggers=function(){for(var i in this.triggerQueues){var o=this.triggerQueues[i],n="up"===i||"left"===i;o.sort(n?e:t);for(var r=0,s=o.length;s>r;r+=1){var a=o[r];(a.options.continuous||r===o.length-1)&&a.trigger([i])}}this.clearTriggerQueues()},i.prototype.next=function(e){this.waypoints.sort(t);var i=n.Adapter.inArray(e,this.waypoints),o=i===this.waypoints.length-1;return o?null:this.waypoints[i+1]},i.prototype.previous=function(e){this.waypoints.sort(t);var i=n.Adapter.inArray(e,this.waypoints);return i?this.waypoints[i-1]:null},i.prototype.queueTrigger=function(t,e){this.triggerQueues[e].push(t)},i.prototype.remove=function(t){var e=n.Adapter.inArray(t,this.waypoints);e>-1&&this.waypoints.splice(e,1)},i.prototype.first=function(){return this.waypoints[0]},i.prototype.last=function(){return this.waypoints[this.waypoints.length-1]},i.findOrCreate=function(t){return o[t.axis][t.name]||new i(t)},n.Group=i}(),function(){"use strict";function t(t){this.$element=e(t)}var e=window.jQuery,i=window.Waypoint;e.each(["innerHeight","innerWidth","off","offset","on","outerHeight","outerWidth","scrollLeft","scrollTop"],function(e,i){t.prototype[i]=function(){var t=Array.prototype.slice.call(arguments);return this.$element[i].apply(this.$element,t)}}),e.each(["extend","inArray","isEmptyObject"],function(i,o){t[o]=e[o]}),i.adapters.push({name:"jquery",Adapter:t}),i.Adapter=t}(),function(){"use strict";function t(t){return function(){var i=[],o=arguments[0];return t.isFunction(arguments[0])&&(o=t.extend({},arguments[1]),o.handler=arguments[0]),this.each(function(){var n=t.extend({},o,{element:this});"string"==typeof n.context&&(n.context=t(this).closest(n.context)[0]),i.push(new e(n))}),i}}var e=window.Waypoint;window.jQuery&&(window.jQuery.fn.waypoint=t(window.jQuery)),window.Zepto&&(window.Zepto.fn.waypoint=t(window.Zepto))}();
	
/**
 * Licensed under MIT
 * @author Ariel Flesler
 * @version 2.1.2
 */
;(function(f){"use strict";"function"===typeof define&&define.amd?define(["jquery"],f):"undefined"!==typeof module&&module.exports?module.exports=f(require("jquery")):f(jQuery)})(function($){"use strict";function n(a){return!a.nodeName||-1!==$.inArray(a.nodeName.toLowerCase(),["iframe","#document","html","body"])}function h(a){return $.isFunction(a)||$.isPlainObject(a)?a:{top:a,left:a}}var p=$.scrollTo=function(a,d,b){return $(window).scrollTo(a,d,b)};p.defaults={axis:"xy",duration:0,limit:!0};$.fn.scrollTo=function(a,d,b){"object"=== typeof d&&(b=d,d=0);"function"===typeof b&&(b={onAfter:b});"max"===a&&(a=9E9);b=$.extend({},p.defaults,b);d=d||b.duration;var u=b.queue&&1<b.axis.length;u&&(d/=2);b.offset=h(b.offset);b.over=h(b.over);return this.each(function(){function k(a){var k=$.extend({},b,{queue:!0,duration:d,complete:a&&function(){a.call(q,e,b)}});r.animate(f,k)}if(null!==a){var l=n(this),q=l?this.contentWindow||window:this,r=$(q),e=a,f={},t;switch(typeof e){case "number":case "string":if(/^([+-]=?)?\d+(\.\d+)?(px|%)?$/.test(e)){e= h(e);break}e=l?$(e):$(e,q);case "object":if(e.length===0)return;if(e.is||e.style)t=(e=$(e)).offset()}var v=$.isFunction(b.offset)&&b.offset(q,e)||b.offset;$.each(b.axis.split(""),function(a,c){var d="x"===c?"Left":"Top",m=d.toLowerCase(),g="scroll"+d,h=r[g](),n=p.max(q,c);t?(f[g]=t[m]+(l?0:h-r.offset()[m]),b.margin&&(f[g]-=parseInt(e.css("margin"+d),10)||0,f[g]-=parseInt(e.css("border"+d+"Width"),10)||0),f[g]+=v[m]||0,b.over[m]&&(f[g]+=e["x"===c?"width":"height"]()*b.over[m])):(d=e[m],f[g]=d.slice&& "%"===d.slice(-1)?parseFloat(d)/100*n:d);b.limit&&/^\d+$/.test(f[g])&&(f[g]=0>=f[g]?0:Math.min(f[g],n));!a&&1<b.axis.length&&(h===f[g]?f={}:u&&(k(b.onAfterFirst),f={}))});k(b.onAfter)}})};p.max=function(a,d){var b="x"===d?"Width":"Height",h="scroll"+b;if(!n(a))return a[h]-$(a)[b.toLowerCase()]();var b="client"+b,k=a.ownerDocument||a.document,l=k.documentElement,k=k.body;return Math.max(l[h],k[h])-Math.min(l[b],k[b])};$.Tween.propHooks.scrollLeft=$.Tween.propHooks.scrollTop={get:function(a){return $(a.elem)[a.prop]()}, set:function(a){var d=this.get(a);if(a.options.interrupt&&a._last&&a._last!==d)return $(a.elem).stop();var b=Math.round(a.now);d!==b&&($(a.elem)[a.prop](b),a._last=this.get(a))}};return p});

var customerpoints = 0;
var currentvariant = null;
 
function syncPrice($productPrice) {		
	var discount = 0;
	var quantity = 1;
	var saletext = '';
	var price_append = '';
	if($('.product-top-content').find('#product-quantity-wrapper').find('.option-select').find('button.active').attr('value')) {
		var pquantity = parseInt($('.product-top-content').find('#product-quantity-wrapper').find('.option-select').find('button.active').attr('value'));
		quantity = pquantity;
		
		if(pquantity > 1) {
			// Discounts
			$('.pricepergram').hide();
			
			if(pquantity == 2) { 
				discount = quantity * currentvariant.price * .05; 
				saletext = ' + Additional 5% Discount'; 
				price_append = '<span class="unit-price">Only $ '+(currentvariant.price * .95 / 100).toFixed(2)+' each</span>'; 
			}
			else if(pquantity == 3) { 
				discount = quantity * currentvariant.price * .07; 
				saletext = ' + Additional 7% Discount'; 
				price_append = '<span class="unit-price">Only $ '+(currentvariant.price * .93/ 100).toFixed(2)+' each</span>'; 
			}
			else if(pquantity == 5) { 
				discount = quantity * currentvariant.price * .1; 
				saletext = ' + Additional 10% Discount'; 
				price_append = '<span class="unit-price">Only $ '+(currentvariant.price * .9/ 100).toFixed(2)+' each</span>'; 
			}
			else if(pquantity == 10) { 
				discount = quantity * currentvariant.price * .15; 
				saletext = ' + Additional 15% Discount'; 
				price_append = '<span class="unit-price">Only $ '+(currentvariant.price * .85/ 100).toFixed(2)+' each</span>'; 
			}
			else if(pquantity == 20) { 
				discount = quantity * currentvariant.price * .2; 
				saletext = ' + Additional 20% Discount'; 
				price_append = '<span class="unit-price">Only $ '+(currentvariant.price * .8/ 100).toFixed(2)+' each</span>'; 
			}			
		}
	}
  if ($('#product-quantity-wrapper').is(':visible')) {
    if ($('#add-on-message').is(':visible')) {
      if ($('#add-on-message').data('cart') + ((currentvariant.price * quantity) - discount) >= 1000) {
        $('#add-on-message').hide();
        $('#AddToCart').show();
      }
    } else {
      if ($('#add-on-message').data('cart') + ((currentvariant.price * quantity) - discount) < 1000) {
        $('#add-on-message').show();
        $('#AddToCart').hide();
      }
    }
  }
  
	// Regardless of stock, update the product price    
	$('#product-quantity').val(quantity);
    $productPrice.html( Shopify.formatMoney(((currentvariant.price * quantity) - discount)).replace('$', '<span class="dollar">$</span>').replace('.', '<span class="cents">.')+'</span>'+price_append);
    
    $('#sale-ProductPrice').html(Shopify.formatMoney(currentvariant.compare_at_price * quantity));    
    $('#sale-PercentOff').html('Save ' + Math.round(((currentvariant.compare_at_price * quantity) - (currentvariant.price * quantity)) / (currentvariant.compare_at_price * quantity) * 100) + '% '+ saletext);
    
    // Sync Members Price
    $('#member-price').html(Shopify.formatMoney((Math.floor(currentvariant.price * 0.8 / 100) * 100)));
    $('#member-points').html(Math.ceil(currentvariant.price * 0.006) * 10);

    //times: 0.006 | ceil | times: 10 | remove: '.0'
}

var selectedVar = '';
  
var selectOption = function(e) {
  e.preventDefault(); 
  var option = $(e.currentTarget).parent().parent().parent().data('pos') - 1;
  var value = $(e.currentTarget).val();
    
  $('#productSelect-option-'+option).val(value).change();
  return false;
}

// Shipping Time
function waitForUD(shipconfig){
	if($('#projectedtime').length <= 0) {
	    if(window.userloc !== "" && typeof shipconfig !== 'undefined' && typeof loadMoment == 'function') { loadMoment().then(function() { $('#shipping-time').shipTime(shipconfig); }); }
	    else { setTimeout(function(){ waitForUD(shipconfig); },200); }

    }
 
  
}

// Wait for Stamped
function waitForStamped() {
	if(typeof StampedFn !== 'undefined') { 
		StampedFn.reloadUGC();
	}
	else { setTimeout(function(){ waitForStamped(); },200); }
}

var checked_product_btns = false;
window['productPage'] = function (options) {
  var moneyFormat = options.money_format,
      variant = options.variant,
      selector = options.selector,
      product = options.product;
                        
  // Selectors
  var $addToCart = $('#AddToCart'),
      $productPrice = $('#ProductPrice'),
      $cartelPrice = $('#cartel-price'),
      $membersPoints = $('#member-points'),
      $ProductPhoto = $('#ProductPhoto'),
      $comparePrice = $('#ComparePrice'),
      $addToCartText = $('#AddToCartText'),
      $fitsthesejoints = $('#fitsthesejoints'),
      $ggprice = $('.ggprice'),
      $vlowstock = $('.variant-lowstock'),
      $productfit = $('#product-fit'),
      $skutag = $('.skutag'),
      $options = $('#product-options'),
      $quantityselect = $('#product-quantity');
  
  
  $('.product-top-content').find('#product-quantity-wrapper').find('.option-select').find('button:first').addClass('active');
  $('.product-top-content').find('#product-quantity-wrapper').find('.option-select').find('button').click(function(event) {
    event.preventDefault();
    $('.product-top-content').find('#product-quantity-wrapper').find('.option-select').find('button').each(function(i,e) {
      $(e).removeClass('active');
    })
    $(event.currentTarget).addClass('active');
    syncPrice($productPrice);
  });
  
  
  $vlowstock.hide();

  if(variant) {  	
	currentvariant = variant;
	if(currentvariant.hasOwnProperty("featured_image") && currentvariant.featured_image !== null) {		
		var variant_thumb = $('#ProductPhotoContainer .royalSlider .rsThumbs .rsTmb[data-image-id="'+currentvariant.featured_image.id+'"]');
		if(variant_thumb.length > 0) {			
			var slider = $ProductPhoto.data('royalSlider');
			if(slider) {
				slider.goTo(variant_thumb.parent().index());
			}			
		}
	}
		
	if(variant.available) {
		var shipping_est_options = {
			"deadline": {
	            hour: window.deadlinehour,
	            minute: 0
	        }
		};
		
		$.getJSON("//warely.io/apps/marketplace/estimate-shipping.php?variant_id="+variant.id, function(resp) {
			$('#shipping-supplier-message').html($('#shipping-supplier-message').attr('data-default'));
			if(resp.success) {
				if(resp.hasOwnProperty('leadtime')) {
					shipping_est_options.leadtime = resp.leadtime;
				}
				
				if(resp.hasOwnProperty('backlog')) {
					shipping_est_options.backlog_days = resp.backlog;
					if(resp.backlog > 0) {
						$('#shipping-supplier-message').html('Fulfilled by <strong>'+resp.supplier+'</strong> - This vendor is experiencing shipping delays.');
					}
				}
			} 
			waitForUD(shipping_est_options);
		});
		
		if($('#optional-addons').length > 0) {
			$.getJSON("//warely.io/apps/recommendations/addons.php?vid="+variant.id, function(resp) { 
				$('#optional-addons-container, #addons-popup-content').html('');
								
				if(!jQuery.isEmptyObject(resp) && $('#included-addons .addon').length > 0) {
					$('#optional-addons').show();
										
					$.each(resp, function(type, addons) {
						
						if(addons.length > 0) {


							let variantDetails = fetch(`${addons[0].product.handle}/?view=data`).then(response => response.text())
							variantDetails.then(data => {
								if(!data) return
								let html = new DOMParser().parseFromString(data, 'text/html');
								let productDeatils = JSON.parse(html.getElementById(`${addons[0].product.handle}`).textContent);
								
								var vtitle = addons[0].product.title;
								if(!addons[0].variant.title.includes('Default Title')) {
									vtitle = addons[0].variant.title.split('[')[0] + ' - '+addons[0].product.title;
								}
								
								if(productDeatils.available != "false"  && productDeatils.club_price != ''){
									// Add top one of each
									$('#optional-addons-container').append('<a href="#" class="noss addon animated fadeInRight" data-vid="'+addons[0].variant.id+'"><span class="img-holder"><img src="'+Shopify.resizeImage(addons[0].image, '80x96_crop_center')+'" alt="" width="40" height="48" /><span class="icon"><i class="icon-plus"></i><i class="icon-ok"></i><i class="icon-minus"></i></span></span><span class="content"><span class="title">'+vtitle+'</span><span class="price">+$'+addons[0].price+' <span class="green animated fadeIn">(Added to Cart!)</span></span></span></a>');
								}
								


							}).catch(err => { 
							})


							
							
							// Assemble modal
							// $('#addons-popup-content').append('<h4>'+type+' Addons</h4>');
							$.each(addons, function(i, a) {
								let variantDetailsPopUp = fetch(`${a.product.handle}/?view=data`).then(response => response.text())
								variantDetailsPopUp.then(data => {
									if(!data) return
									let html = new DOMParser().parseFromString(data, 'text/html');
									let productDeatilsPopUp = JSON.parse(html.getElementById(`${a.product.handle}`).textContent)

									if(productDeatilsPopUp.available != "false" && productDeatilsPopUp.club_price != ''){
										var vtitle = a.product.title;
										if(!a.variant.title.includes('Default Title')) {
											vtitle = a.product.title+'<br /><small>'+a.variant.title.split('[')[0]+'</small>';
										}
										
										$('#addons-popup-content').append('<div class="grid center-grid" style="border-top: 1px solid #d6dee4; padding-top: 8px;"><div class="grid__item large--one-sixth one-quarter"><img src="//www.smokecartel.com/cdn/shop/t/38/assets/productgridblank.gif?v=118161956261754350281733865434" data-src="'+Shopify.resizeImage(a.image, 'medium')+'" style="border-radius: 5px;" class="lazyload" alt="" /></div><div class="grid__item large--one-half three-quarters"><p><a href="/products/'+a.product.handle+'" style="color: #000;" target="_blank">'+vtitle+'</a></p></div><div class="grid__item large--one-third three-quarters large--text-right text-left"><p class="price" style="margin-bottom: 10px;"><span class="dollar">$</span>'+a.price.replace('.', '<span class="cents">.')+'</span></p><p><a href="#" class="btn--muted addon noss" data-vid="'+a.variant.id+'"><span class="pre"><i class="icon-plus"></i> Add to Cart</span><span class="added"><i class="icon-ok"></i> Added to Cart</span></a></p></div></div>');
									}

								}).catch(err => { 
								})
								
							});
							// $('#addons-popup-content').append('<br />');
						}
					});
					
					$('body').on('click','#optional-addons-container .addon, #addons-popup-content .addon',function(event) {
						event.preventDefault();
						
						var $l = $(this);
						var vid = $(this).attr('data-vid');
						console.log(vid);
						if(vid) {
							if($(this).hasClass('active')) {						
								try {
									Shopify.removeItem(vid, function() {		
										$l.removeClass('active');	
										Shopify.getCart();
									});
								}
								catch(error) { console.log(error); }
							}
							else {
								// Add
								try {
									Shopify.addItem(vid, 1, function() {		
										$l.addClass('active');	
										Shopify.getCart();
									});
								}
								catch(error) { console.log(error); }
							}
						}
					});
				}
				else {
					$('#optional-addons').hide();
				}
			});
		}
	}
		
	selectedVar = variant;
    // Select a valid variant if available
    if(variant.available) {
	    $('.stock-claim').show();
	    
     	// Available, enable the submit button, change text, show quantity elements
     	$addToCart.removeClass('disabled').prop('disabled', false);
      	$addToCartText.html("Add to Cart");
      	customerpoints = $('#PageContainer').find('.pointscount').text();
      	$ggprice.html(Shopify.formatMoney(variant.price * 0.07).replace(' ', ''));
      	
      	// Set Points
		if($('#points-btn').length > 0) {	
			$pointsBtn = $('#points-btn');	
			var needpoints = variant.price;
			if(variant.price > 5000) { needpoints = variant.price * 0.5; } else { needpoints = Math.floor(variant.price * 1.5); }
			
			//console.log(parseInt(customerpoints));
			//console.log(needpoints);
			
			if(parseInt(customerpoints) >= needpoints) {
				console.log($pointsBtn);
				$pointsBtn.find('a:first').attr('data-need', needpoints).find('span.pointsneeded').html('('+needpoints+' Points)');
				$pointsBtn.show();
			}
			else {
				$pointsBtn.hide();
			}
		}
		
		if($cartelPrice.length > 0) {
			if(parseInt($membersPoints.text()) > parseInt(customerpoints)) {
				$('#members-price-redeem').hide();
			}
			else {
				$('#members-price-redeem').show();
			}
		}
		
		if(variant.inventory_quantity < 10) {
			$('#variant_'+variant.id+'_countdown').show();
		}
		
		$('#shipping-est, #oneclick-btn, #cartel-price').show();
		$('.soldout-btn').hide();
    } else {
    	// Sold out, disable the submit button, change text, hide quantity elements
		$addToCart.addClass('disabled').prop('disabled', true);
		$addToCartText.html("Sold Out");
		$('#shipping-est, #oneclick-btn, #cartel-price').hide();
		$('.stock-claim').hide();
		
		$('.soldout-btn').show();
		
		if($('#points-btn').length > 0) {
			$('#points-btn').hide();
		}
		
		$('#product-options').find('.option-select-button').each(function(button) {
			if (!$(button).prop('disabled')) {
				$(button).click();
				return false;
			}
		})
    }
    
    // Regardless of stock, update the product price    
    syncPrice($productPrice);
          
          async function updateMulberryVariant(variant) {
            if (window && !window.mulberryShop) {
              return
            }
          let response = await mulberryShop.getProductData(mulberryShop.getProductUrl());
          let product = response.product;            
              newVariant = product.variants.find(i => i.id == variant.id)
//               console.log('mulberry getting variant: ', variant, product, newVariant)
              let newOffer
              if (window && window.mulberryShop && window.mulberry && window.mulberry.core) {
              newOffer = await mulberry.core.getWarrantyOffer({
                  id: product.id,
                  title: product.title,
                  price: newVariant.price,
                  detail: product,
              });
              }
              if(newOffer && newOffer.length > 0) {
                if (window && window.mulberryShop && window.mulberry) {
                  window.pdpModal.updateOffer(newOffer)                
                }
//                 mulberry.inline.updateOffer(newOffer)
              }
          }
          updateMulberryVariant(variant)

         
    allOptions = {} 
     
    $options.find('button.active').removeClass('active');
    if(variant.option1 != null) {
	    $options.find('.option[data-pos="1"]').find('button[value="'+variant.option1.replace(/'/g, "\\'").replace(/"/g, '\\"')+'"]').addClass('active');
	    //console.log(product.variants)
	    
	    var availableOptions = [];
	    var allOptions = [];
	    $.each(product.variants, function(i, pv) {
		    [pv.option1, pv.option2, pv.option3].forEach(function(option) {
			    if (!allOptions.includes(option) && option != null) allOptions.push(option)
			    if (pv.available) {
			    	if (option != null) availableOptions.push(option);
			    }
		    });
		    
			if(pv.option2 == null && pv.option3 == null) {
				if (!pv.available) {
					$options.find('.option[data-pos="1"]').find('button[value="'+pv.option1.replace(/'/g, "\\'").replace(/"/g, '\\"')+'"]').prop("disabled", true);
				}
			}
	    });
	    //console.log(allOptions, availableOptions)
	    allOptions.forEach(function(option) {
		    if (!availableOptions.includes(option)) {
				$options.find('.option[data-pos="1"]').find('button[value="'+option.replace(/'/g, "\\'").replace(/"/g, '\\"')+'"]').prop("disabled", true);
				$options.find('.option[data-pos="2"]').find('button[value="'+option.replace(/'/g, "\\'").replace(/"/g, '\\"')+'"]').prop("disabled", true);
				$options.find('.option[data-pos="3"]').find('button[value="'+option.replace(/'/g, "\\'").replace(/"/g, '\\"')+'"]').prop("disabled", true);
			}
	    })
	    
	    $.each(product.variants, function(i, pv) {
		   
		});
    } 
    if(variant.option2 != null) {
      	//console.log(variant.option2);
	    $options.find('.option[data-pos="2"]').find('button[value="'+variant.option2.replace(/'/g, "\\'").replace(/"/g, '\\"')+'"]').addClass('active');
	    $options.find('.option[data-pos="2"]').find('button').prop("disabled",true);
	    
	    // Set all invalid option2s
	    var availopts = [];
	    $.each(product.variants, function(i, pv) {
			if(pv.option1 == variant.option1 && pv.available && !availopts.includes(pv.option2)) {
				availopts.push(pv.option2);
				$options.find('.option[data-pos="2"]').find('button[value="'+pv.option2.replace(/'/g, "\\'").replace(/"/g, '\\"')+'"]').prop("disabled", false);
			}
	    });
    } 
    if(variant.option3 != null) {
	    $options.find('.option[data-pos="3"]').find('button[value="'+variant.option3.replace(/'/g, "\\'").replace(/"/g, '\\"')+'"]').addClass('active');
	    $options.find('.option[data-pos="3"]').find('button').prop("disabled",true);
	    
	    // Set all invalid option2s
	    var availopts = [];
	    $.each(product.variants, function(i, pv) {
			if(pv.option1 == variant.option1 && pv.available && !availopts.includes(pv.option3)) {
				availopts.push(pv.option3);
				$options.find('.option[data-pos="3"]').find('button[value="'+pv.option3.replace(/'/g, "\\'").replace(/"/g, '\\"')+'"]').prop("disabled", false);
			}
	    });
	    //console.log(availopts);
    } 
    
	
    
    
    
/*
    if($quantityselect.length > 0) {
	    if(variant.inventory_quantity <= 1) { $quantityselect.parent().hide(); }
	    else { $quantityselect.parent().show(); }
	    
	    $quantityselect.find('option').each(function(i, o) {
		    if($(o).val() > variant.inventory_quantity) {
			    // Hide option
			    if($(o).is(':selected')) { $quantityselect.find('option:eq(0)').prop('selected', true); }
			    $(o).hide();
		    }
		    else {
			    $(o).show();
		    }
	    });
    }
*/
    
    // Add SKU
    $skutag.html(variant.sku);

    // Also update and show the product's compare price if necessary
    if (variant.compare_at_price > variant.price) {
      $comparePrice.html('<strong class="onsale red">On Sale!</strong>	&nbsp;<s id="sale-ProductPrice" class="black">' + Shopify.formatMoney(variant.compare_at_price, moneyFormat)+'</s> - <span class="red" id="sale-PercentOff">Save '+Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100)+'%<\/span>')
        .show();
    } else {
      $comparePrice.hide();
    }
	
	// Adjust Fits
	if($fitsthesejoints.length > 0 && variant.title != 'Default Title') {
		if(variant.title.includes('10mm') || variant.title.includes('14.5mm') || variant.title.includes('14mm') || variant.title.includes('18.8mm') || variant.title.includes('18mm') || variant.title.includes('19mm')) {
			$fitsthesejoints.find('.jointicon').hide();
			
			if(variant.title.includes('Male')) {
				$.each(variant.options, function(i, o) {
					if(o.includes('10mm')) {
						$fitsthesejoints.find('.jointicon.10mm.female').attr('style', 'display: inline-block;');
					}
					else if(o.includes('14.5mm') || o.includes('14mm')) {
						$fitsthesejoints.find('.jointicon.14mm.female').attr('style', 'display: inline-block;');
					}
					else if(o.includes('18.8mm') || o.includes('18mm') || o.includes('19mm')) {
						$fitsthesejoints.find('.jointicon.18mm.female').show();
					}
				});
			}
			else if( variant.title.includes('Female')) {
				$.each(variant.options, function(i, o) {
					if(o.includes('10mm')) {
						$fitsthesejoints.find('.jointicon.10mm.male').attr('style', 'display: inline-block;');
					}
					else if(o.includes('14.5mm') || o.includes('14mm')) {
						$fitsthesejoints.find('.jointicon.14mm.male').attr('style', 'display: inline-block;');
					}
					else if(o.includes('18.8mm') || o.includes('18mm') || o.includes('19mm')) {
						$fitsthesejoints.find('.jointicon.18mm.male').show();
					}
				});
			}
			else {
				$.each(variant.options, function(i, o) {
					if(o.includes('10mm')) {
						$fitsthesejoints.find('.jointicon.10mm').attr('style', 'display: inline-block;');
					}
					else if(o.includes('14.5mm') || o.includes('14mm')) {
						$fitsthesejoints.find('.jointicon.14mm').attr('style', 'display: inline-block;');
					}
					else if(o.includes('18.8mm') || o.includes('18mm') || o.includes('19mm')) {
						$fitsthesejoints.find('.jointicon.18mm').show();
					}
				});
			}
		}
	}
	
	$('#product-options.collapsed').find('button[disabled]').attr('title', 'Sold Out');
    $('#product-options.collapsed').find('button:not([disabled])').each(function() {
	    $(this).parent().prepend(this);
	});
	$('#product-options.collapsed .option-select').each(function() {
		var totalwidth = 0;
		$(this).find('button').each(function() {
			totalwidth += ($(this).width() + 32);
		});
		$(this).find('.inner').width(totalwidth+'px');
	});
	
	if($productfit.length > 0 && variant.title != 'Default Title' && product.variants.length > 1) {
		// Fits or not code
	    var variantsize = '';
	    if($.inArray('14.5mm', product.tags)) {
		    variantsize = '14.5mm';
	    }
	    else if($.inArray('18.8mm', product.tags)) {
		    variantsize = '18.8mm';
	    }
	    else if($.inArray('10mm', product.tags)) {
		    variantsize = '10mm';
	    }
	    
	    if(variant.title.toUpperCase().includes('14.5MM') || variant.title.toUpperCase().includes('14MM')) {
		    variantsize = '14.5mm';
	    }
	    else if(variant.title.toUpperCase().includes('18.8MM') || variant.title.toUpperCase().includes('18MM') || variant.title.toUpperCase().includes('18.5MM') || variant.title.toUpperCase().includes('19MM')) {
		    variantsize = '18.8mm';
	    }
	    else if(variant.title.toUpperCase().includes('10MM')) {
			variantsize = '10mm';
		}
		
		var variantgender = '';
		if($.inArray('Male Joint', product.tags) || $.inArray('Male joint', product.tags) || $.inArray('For Female Joints', product.tags)) {
			variantgender = 'male';
		}
		else if($.inArray('Female Joint', product.tags) || $.inArray('For male joints', product.tags) || $.inArray('Female Joint', product.tags)) {
			variantgender = 'female';
		}
		
	    if(variant.title.toUpperCase().indexOf("FEMALE") > -1) { variantgender = 'female'; }
		else if(variant.title.toUpperCase().indexOf("MALE") > -1) { variantgender = 'male'; }

	    $productfit.find('.product-special').each(function() {
		    var validategender = true;
		    if(variant.title.toUpperCase().indexOf("MALE") > -1) { // Has gender in title
			    if($(this).data('requires-gender') == variantgender) {
				    validategender = true;
			    }
			    else {
				    validategender = false;
			    }
		    }
		    else if($(this).data('requires-gender') == variantgender) {
			    validategender = true;
		    }
		    else {
			    validategender = false;
		    }
		    
		   if($(this).data('requires-size') == variantsize && validategender) {
		   	  $(this).removeClass('nofit').addClass('fit'); $(this).find('.doesfit').show(); $(this).find('.notfit').hide();
		   }
		   else {
		   	  $(this).removeClass('fit').addClass('nofit'); $(this).find('.doesfit').hide(); $(this).find('.notfit').show();
		   }
	    });
	}

  } else {
    $addToCart.addClass('disabled').prop('disabled', true);
    $addToCartText.html('Sold Out');
    
    if($('#points-btn').length > 0) { $('#points-btn').hide(); }
  }  
};

// Shiptime
! function(a) {
    function b(b, d) {
        this.element = b, this.options = a.extend({}, c, d);
        try {
            if (void 0 === moment || void 0 === a) throw Error("please include jquery & moment.js")
        } catch (a) {
            console.log(a)
        }
        this.displayShipTime()
    }
    var c = {
        timezone: "-0500",
        deadline: {
            hour: 16,
            minute: 0
        },
        backlog_days: 0,
        shipMethodName: "Free Shipping",
        noShipping: "12/24, 12/25, 12/26, 1/1, 1/19, 2/16, 5/25, 7/4, 9/7, 10/12, 11/11, 11/26",
        leadtime: {
            Alabama: 3,
            Alaska: 4,
            Arizona: 3,
            Arkansas: 3,
            California: 4,
            Colorado: 3,
            Connecticut: 3,
            Delaware: 3,
            Florida: 3,
            Georgia: 3,
            Hawaii: 5,
            Idaho: 3,
            Illinois: 3,
            Indiana: 4,
            Iowa: 4,
            Kansas: 4,
            Kentucky: 3,
            Louisiana: 3,
            Maine: 3,
            Maryland: 3,
            Massachusetts: 3,
            Michigan: 4,
            Minnesota: 3,
            Mississippi: 3,
            Missouri: 4,
            Montana: 4,
            Nebraska: 4,
            Nevada: 3,
            "New Hampshire": 3,
            "New Jersey": 3,
            "New Mexico": 4,
            "New York": 3,
            "North Carolina": 3,
            "North Dakota": 4,
            Ohio: 3,
            Oklahoma: 4,
            Oregon: 4,
            Pennsylvania: 3,
            "Rhode Island": 3,
            "South Carolina": 3,
            "South Dakota": 4,
            Tennessee: 3,
            Texas: 4,
            Utah: 4,
            Vermont: 3,
            Virginia: 3,
            Washington: 3,
            "West Virginia": 3,
            Wisconsin: 3,
            Wyoming: 4
        }
    };
    b.prototype.isWeekday = function(a) {
        return 0 !== a.day()
    }, b.prototype.isExcluded = function(a) {
        var b = this.options.noShipping.split(",");
        void 0 == a._isAMomentObject && (a = a(a, "MM-DD-YYYY"));
        for (var c = 0; c < b.length; c++)
            if (a.utcOffset("-0500").format("M/D") == b[c]) return !0;
        return !1
    }, b.prototype.shipDay = function(a) {
        return moment().utcOffset(this.options.timezone).isSame(a, "d") ? "Today" : a.format("dddd")
    }, b.prototype.shippingDeadline = function(a, b) {
        for (var c = moment().utcOffset(this.options.timezone).hour(a).minute(b).second(0); this.isExcluded(c);) c.add(24, "h");
        //console.log(c);
        return moment().utcOffset(this.options.timezone).hour() >= c.hour() && this.isWeekday(moment().utcOffset(this.options.timezone)), this.isWeekday(c) ? c : 0 === c.day() ? c.add(24, "h") : c.add(48, "h")
    }, b.prototype.timeUntilDeadline = function(a) {
        for (var b = Math.abs(moment().utcOffset(this.options.timezone).diff(a, "m")), c = 0; b >= 60; c++) b -= 60;
        return {
            hours: c,
            minutes: b
        }
    }, b.prototype.projectedDeliveryDate = function(a, b) {
        for (var c = a.add(this.options.leadtime[b]+this.options.backlog_days, "day"); this.isExcluded(c);) c.add("h", 24);
        c.add("h", 24);
        return this.isWeekday(c) ? c : 0 === c.day() ? c.add("h", 24) : c.add("h", 48)
    }, b.prototype.displayShipTime = function() {
        var b = this,
            c = this.shippingDeadline(this.options.deadline.hour, this.options.deadline.minute),
            d = this.timeUntilDeadline(c);
        a(this.element).html(""), this.options.leadtime && ("United States" == window.userloc[0] ? a(b.element).append('<strong class="white">Order within <span class="time-left">' + d.hours + " hrs " + d.minutes + ' mins</span></strong> - Estimated delivery <span id="projectedtime">' + b.projectedDeliveryDate(c, window.userloc[2]).format("dddd, MMMM Do") + ' *</span><span class="use_here pull-right">Shipping to <select id="delivery-state"><option>Alabama</option><option>Alaska</option><option>Arizona</option><option>Arkansas</option><option>California</option><option>Colorado</option><option>Connecticut</option><option>Delaware</option><option>Florida</option><option>Georgia</option><option>Hawaii</option><option>Idaho</option><option>Illinois</option><option>Indiana</option><option>Iowa</option><option>Kansas</option><option>Kentucky</option><option>Louisiana</option><option>Maine</option><option>Maryland</option><option>Massachusetts</option><option>Michigan</option><option>Minnesota</option><option>Mississippi</option><option>Missouri</option><option>Montana</option><option>Nebraska</option><option>Nevada</option><option>New Hampshire</option><option>New Jersey</option><option>New Mexico</option><option>New York</option><option>North Carolina</option><option>North Dakota</option><option>Ohio</option><option>Oklahoma</option><option>Oregon</option><option>Pennsylvania</option><option>Rhode Island</option><option>South Carolina</option><option>South Dakota</option><option>Tennessee</option><option>Texas</option><option>Utah</option><option>Vermont</option><option>Virginia</option><option>Washington</option><option>West Virginia</option><option>Wisconsin</option><option>Wyoming</option></select></span>') : a("#shipping-est i.sooner").remove()), $("#delivery-state").find('option:contains("' + window.userloc[2] + '")').prop("selected", !0), $("#delivery-state").change(function() {
            window.userloc[2] = $("option:selected", this).text(), Cookies2.set("userdata", window.userloc.join(","), {
                expires: 7,
            }), b.displayShipTime()
        })

      localStorage.setItem('new_shipping_text', '<strong class="white">Order within <span class="time-left">' + d.hours + " hrs " + d.minutes + ' mins</span></strong> - Estimated delivery <span id="projectedtime">' + b.projectedDeliveryDate(c, window.userloc[2]).format("dddd, MMMM Do") + ' *</span><span class="pull-right">Shipping to <select id="delivery-state"><option>Alabama</option><option>Alaska</option><option>Arizona</option><option>Arkansas</option><option>California</option><option>Colorado</option><option>Connecticut</option><option>Delaware</option><option>Florida</option><option>Georgia</option><option>Hawaii</option><option>Idaho</option><option>Illinois</option><option>Indiana</option><option>Iowa</option><option>Kansas</option><option>Kentucky</option><option>Louisiana</option><option>Maine</option><option>Maryland</option><option>Massachusetts</option><option>Michigan</option><option>Minnesota</option><option>Mississippi</option><option>Missouri</option><option>Montana</option><option>Nebraska</option><option>Nevada</option><option>New Hampshire</option><option>New Jersey</option><option>New Mexico</option><option>New York</option><option>North Carolina</option><option>North Dakota</option><option>Ohio</option><option>Oklahoma</option><option>Oregon</option><option>Pennsylvania</option><option>Rhode Island</option><option>South Carolina</option><option>South Dakota</option><option>Tennessee</option><option>Texas</option><option>Utah</option><option>Vermont</option><option>Virginia</option><option>Washington</option><option>West Virginia</option><option>Wisconsin</option><option>Wyoming</option></select></span>')
        
    }, a.fn.shipTime = function(a) {
        return this.each(function() {
            new b(this, a)
        })
    }
}(jQuery);

window['activateProductLikes'] = function(likes, currentlikes) {	 

}


// mulberry submit
function submitMulberryWarranty() {
	  let pdpModal  
	
	async function initMulberry() {
        window.mulberryInitted = true
		let response = await mulberryShop.getProductData(mulberryShop.getProductUrl());
		let product = response.product;
		 
		let selectedVariant = product.variants.find(i => i.id == currentvariant.id)
        if (!window.mulberry || !window.mulberry.core) {
        	return
        }
		const offer = await mulberry.core.getWarrantyOffer({
			id: product.id,
			title: product.title,
			price: selectedVariant.price,
			detail: product,
		});
		
		if(offer.length > 0) {
			console.log(offer);
			
			await window.mulberry.core.init({
				publicToken: 'UaXT8a542rsLAWAjh9tJrzuR9lE',
			})
			const { mulsettings } = mulberry.core			
			await mulberry.learnMore.init({ mulsettings });
			
			window.pdpModal = await mulberry.modal.init({
				offers: offer, 
				settings: mulberry.core.settings,
				onWarrantySelect: async (warranty) => {
					console.log('warranty toggled', warranty);
					const result = await mulberryShop.getWarrantyVariant(warranty);
					
					var warranty_variant_id = product.variant_id;
					if(typeof product.variant_id == 'undefined' || product.variant_id == null) {
						warranty_variant_id = currentvariant.id;
					}
					
					await mulberryShop.addWarrantyToCart(result.shopify_variant_id, {title: product.title, variantId: warranty_variant_id});
					$('#added-extend').prop('checked', true);
					mulberry.modal.close();
					submitProduct();
					smoothTo('/cart');
					// if(warranty_offer) {
					// 	submitProduct();
					// }
				},
				onWarrantyDecline: () => {
					mulberry.modal.close();
					// smoothTo('/cart');
					// if(warranty_offer) {
					// 	submitProduct();
					// }
				}
			});
			
			$('.extend-container').show();
			
			mulberry.inline.init({
				offers: offer,
				settings: mulberry.core.settings,
				selector: '#extend-offer-secondary',
				onWarrantyToggle: async (warranty) => {
					console.log('warranty toggled', warranty);
					if(warranty.isSelected) {
						const result = await mulberryShop.getWarrantyVariant(warranty.offer);
						await mulberryShop.addWarrantyToCart(result.shopify_variant_id, product);
						$('#added-extend').prop('checked', true);
					}
					else {
						$('#added-extend').prop('checked', false);
						Shopify.getCart(function(cart) {
							mulberryShop.removeDetachedWarranty(cart);
						});
					}
				}
			});

			
			$('#added-extend').change(function(event) {
				event.preventDefault();				
				if($(this).prop('checked')) {
					// Adding
					$(this).prop('checked', false);
// 					mulberry.modal.open();
                  window.pdpModal.open();
				}
				else {
					// Remove
					Shopify.getCart(function(cart) {
						mulberryShop.removeDetachedWarranty(cart);
					});
				}
			});			
		}
	}
	
    if(!window.mulberryShop && !window.mulberryInitted){
      var script = document.createElement('script');
      script.src = "https://ottawa.getmulberry.com/app/adapter.js";
      document.head.appendChild(script); 
    }
	if(typeof mulberry != 'undefined') {
		initMulberry();
	}
	else {
		document.addEventListener('mulberry-shopify:loaded', () => {
			initMulberry();
		});
	}
	
}


// Handle Form Submit  
function submitProduct() {
	$('#glassguard').hide();
	
	// Check if direct checkout
	var directcheckout = false;
	if($('#directcheckout').val() == 'true') { directcheckout = true; }

  console.log("Added");
	// Adoons
	var addons = $('input.addon-vid:checked');
	if(addons.length > 0) {
		addons.each(function(i,e) {
			try {
				Shopify.addItem($(e).val(), 1, function() {		
					console.log('Added 1x '+$(e).val());		
				});
			}
			catch(error) {
				console.log(error);
			}
		});
	}
	
	Shopify.addItemFromForm($('#AddToCartForm'), function(e) { 
		$('#AddToCartForm').addClass('loading-atc')
		if(directcheckout) { $('#checkout-direct').trigger('click'); }
		else { 
			populateCartDrawer(e)
			setTimeout(function() {
				$('#AddToCartForm').removeClass('loading-atc');	
			}, 1000);
			// smoothTo('/cart?view=added#'+$('#AddToCartForm').attr('data-handle'));
		} 
	});
}

function addGlassGuard(quantity, pid, ptitle) {
	$.ajax({
	    type: 'POST',
		url: '/cart/add.js',
		data: {
			quantity: Math.ceil(quantity),
			id: '31598651736147',
			properties: {
				'item_id' : pid,
				'item_name' : ptitle,
				'policy_id' : guid(),
			}
		},
		dataType: 'json',
		success: function(line_item) { 
			submitProduct();
		},
		error: function() {
			submitProduct();
		}
	});
}

function activateProductBtns(ggpid, ggptitle) {	
	var clicked = false;
	var warranty_offer = false;
	$('#AddToCart').click(function(event) {
		var _learnq = _learnq || [];
		_learnq.push(['track', 'Added to Cart', item]);
		  		
		if(!$(this).hasClass('disabled') && clicked === false) {	
			if($('#glassguard').length > 0) {
				if($('#addggplan').is(':checked')) {
					addGlassGuard((currentvariant.price * 0.07), ggpid, ggptitle);
				}
				else {
					$('#glassguard').show();
					window.scrollTo(0,0);
				}
			}
			else if($('#extend-offer').length > 0 && $('#extend-offer').is(':visible') && !$('#added-extend').is(':checked') && mulberry && mulberry.hasOwnProperty('modal')) {
				// Has warrranty offers, but is not checked
				warranty_offer = true;
// 				mulberry.modal.open();
              window.pdpModal.open();
			}
			else { 
				// $(this).prop('disabled', true);
				submitProduct(); 
			}
		}
		event.preventDefault();
	});
		
	$('#AddToCartForm').submit(function(event) {
		event.preventDefault();
		submitProduct();
	});
  
    // submitMulberryWarranty()

	  let pdpModal  
	
	async function initMulberry() {
        window.mulberryInitted = true
		let response = await mulberryShop.getProductData(mulberryShop.getProductUrl());
		let product = response.product;
		 
		let selectedVariant = product.variants.find(i => i.id == currentvariant.id)
        if (!window.mulberry || !window.mulberry.core) {
        	return
        }
		const offer = await mulberry.core.getWarrantyOffer({
			id: product.id,
			title: product.title,
			price: selectedVariant.price,
			detail: product,
		});
		
		if(offer.length > 0) {
			console.log(offer);
			
			await window.mulberry.core.init({
				publicToken: 'UaXT8a542rsLAWAjh9tJrzuR9lE',
			})
			const { mulsettings } = mulberry.core			
			await mulberry.learnMore.init({ mulsettings });
			
			window.pdpModal = await mulberry.modal.init({
				offers: offer, 
				settings: mulberry.core.settings,
				onWarrantySelect: async (warranty) => {
					console.log('warranty toggled', warranty);
					const result = await mulberryShop.getWarrantyVariant(warranty);
					
					var warranty_variant_id = product.variant_id;
					if(typeof product.variant_id == 'undefined' || product.variant_id == null) {
						warranty_variant_id = currentvariant.id;
					}
					
					await mulberryShop.addWarrantyToCart(result.shopify_variant_id, {title: product.title, variantId: warranty_variant_id});
					$('#added-extend').prop('checked', true);
					mulberry.modal.close();
					// submitProduct();
					// smoothTo('/cart');
					if(warranty_offer) {
						submitProduct();
					}
				},
				onWarrantyDecline: () => {
					mulberry.modal.close();
					// smoothTo('/cart');
					if(warranty_offer) {
						submitProduct();
					}
				}
			});
			
			$('.extend-container').show();
			
			mulberry.inline.init({
				offers: offer,
				settings: mulberry.core.settings,
				selector: '#extend-offer-secondary',
				onWarrantyToggle: async (warranty) => {
					console.log('warranty toggled', warranty);
					if(warranty.isSelected) {
						const result = await mulberryShop.getWarrantyVariant(warranty.offer);
						await mulberryShop.addWarrantyToCart(result.shopify_variant_id, product);
						$('#added-extend').prop('checked', true);
					}
					else {
						$('#added-extend').prop('checked', false);
						Shopify.getCart(function(cart) {
							mulberryShop.removeDetachedWarranty(cart);
						});
					}
				}
			});

			
			$('#added-extend').change(function(event) {
				event.preventDefault();				
				if($(this).prop('checked')) {
					// Adding
					$(this).prop('checked', false);
// 					mulberry.modal.open();
                  window.pdpModal.open();
				}
				else {
					// Remove
					Shopify.getCart(function(cart) {
						mulberryShop.removeDetachedWarranty(cart);
					});
				}
			});			
		}
	}
	
    if(!window.mulberryShop && !window.mulberryInitted){
      var script = document.createElement('script');
      script.src = "https://ottawa.getmulberry.com/app/adapter.js";
      document.head.appendChild(script); 
    }
	if(typeof mulberry != 'undefined') {
		initMulberry();
	}
	else {
		document.addEventListener('mulberry-shopify:loaded', () => {
			initMulberry();
		});
	}









		
	$('#optional-addons .show-addons-popup').click(function(event) {
		event.preventDefault();
		
		$('#addons-popup').show();		
	});
	
	var current_fulfillment_services = [];
	if(window.hasOwnProperty('current_cart')) {
		var cart_parts = window.current_cart.split(',');
		$.each(cart_parts, function(i, e) {
			if(e != '') {
				var parts = e.split('|');
				if(parts.length == 2 && !current_fulfillment_services.includes(parts[1])) {
					current_fulfillment_services.push(parts[1]);
				}
			}
		});
	}
	
	$('#product-options').find('.option-select .option-select-button.primary-option').each(function(i, e) {		
		if($(this).attr('disabled') == 'disabled') {
			// Not available, see if backup option exists
			var check_val = $(this).val();
			var found_backup = false;			
			$('#product-options').find('.option-select .option-select-button.backup-option').each(function(j, k) {				
				if($(k).val().includes(check_val+' [DUPLICATE') && $(k).attr('disabled') != 'disabled' && !found_backup) {
					// Switching suppliers
					$(k).show();
					$(e).hide();
					found_backup = true;
				}
			});
		}
	});
	
	// See if we want to show option from another supplier to save # of shipments
	if(current_fulfillment_services.length > 0) {
		$('#product-options').find('.option-select .option-select-button:visible').each(function(i, e) {
			// Check to see if not being fulfilled from same vendor
			if((typeof $(this).attr('data-fulfillment-service') == 'undefined' || $(this).attr('data-fulfillment-service') == '') && 
			!current_fulfillment_services.includes($(this).attr('data-fulfillment-service'))) {
				// Attempt to see if any hidden options fit
				var check_val = $(this).val().split('[')[0].trim();
				var found = false;
				$.each(current_fulfillment_services, function(j, service) {
					if(!found) {
						var find_option = $('#product-options').find('.option-select .option-select-button[data-fulfillment-service="'+service+'"][value*="'+check_val.replace(/'/g, "\\'").replace(/"/g, '\\"')+'"]:hidden:enabled');
						if(find_option.length > 0) {
							// Found one valid option from supplier in cart
							$(e).hide();
							if($(e).hasClass('active')) {
								find_option[0].click();
							}
							find_option.show();
							found = true;
						}
					}
				})
			}
		});
	}
	
	$('#question-form').submit(function(event) {
		var qform = $(this).serialize();
		$.ajax({
			type: "POST",
			url: '//questions.smokecartel.com/post.php',
			data: qform,
			success: function(response) {
				if(response == 'success') { $('#question-ask').html('<strong class="green">We\'ll get back to you shortly!  Your question will be passed along and we\'ll have a response soon.</strong>'); }
				else { alert(response); }
			}
    	});

		event.preventDefault();
		return false;
	});
	
	// Enable Add Circles
	$('a.add-circle:not(.nochange)').click(function(event) {
		event.preventDefault();
		$(this).toggleClass("active");
		if($(this).data('extra')) {
			$('#'+$(this).data('extra')).show();
		}
	});
	
	// Enable Function Play
	$('a.function-thumb').click(function(event) {
		event.preventDefault();
		var imghref = $(this).find('img').attr('data-src');
		var index = $('img[src="'+imghref+'"]').parent().index();
		var slider = $("#ProductPhoto").data('royalSlider');
		slider.goTo(index);
		$(this).remove();
	});
	
	// GlassGuard
	$('#addgg').one( "click", function(event) {
		event.preventDefault();	
		addGlassGuard((currentvariant.price * 0.07), ggpid, ggptitle);
	});

	$('.closegg').click(function(event) {
		event.preventDefault();
		submitProduct();
		return false; 
	});
	
	// Enable Popup Clicks
	$('.consumable-type a').click(function(event) {
		event.preventDefault();
		$('#useicons-info').show();
		return false;
	});
	
	// Scroll Bottom Widget
	$(window).scroll($.debounce( 2000, true, function(){
		$('#scroll-bottom-widget').fadeOut(200);
	}));
	$(window).scroll($.debounce( 2000, function(){		
		var elementstop = $('.wrapper.main-content').offset().top;
		var scrollTop = $(window).scrollTop();	
		
		if(scrollTop > elementstop) {
			$('#scroll-bottom-widget').show();
		}
	}));
	
}

function getReviews(pid, product) {
	$.get('//api.smokecartel.com/reviews/products/'+pid+'.txt').done(function(reviews) {
        $('#reviews-data').html(reviews);
        
        if (typeof rjson !== 'undefined') {
	        $reviewshtml = $('#product-reviews-content');
	        var pos_sentiment = ($reviewshtml.attr('data-sentiment-pos')*100).toFixed(2);
	        var neu_sentiment = ($reviewshtml.attr('data-sentiment-neu')*100).toFixed(2);
	        var neg_sentiment = ($reviewshtml.attr('data-sentiment-neg')*100).toFixed(2);
	        
	        if(pos_sentiment > 0 && neu_sentiment > 0 && neg_sentiment > 0) {
		        $('.pos-sentiment').html(pos_sentiment);
		        $('.neu-sentiment').html(neu_sentiment);
		        $('.neg-sentiment').html(neg_sentiment);
		        $('#sentiment').show();
	        }
	        else {
		        $('#sentiment').hide();
	        }
	        
			var metacount = Object.keys(rjson.metascores).length;
			if(rjson.hasOwnProperty('metascores') && metacount > 0) {
				var subcontent = $('#subratings .grid');
				for(var key in rjson.metascores) {
					if(key != '') {
						var scores = rjson.metascores[key];
						var plural = 'Rating';
						if(scores.count > 1) {
							plural = 'Ratings';
						}
						
						var subwidth = 'one-quarter';
						if(metacount == 2) {
							subwidth = 'one-half';
						}
						else if(metacount == 3) {
							subwidth = 'one-third';
						}
						
						subcontent.append('<div class="grid__item large--'+subwidth+' infobox"><div class="subrating-container rounded muted-panel text-center"><div class="grid tight center-grid-all"><div class="grid__item three-fifths"><h4>'+key.replace(/_/g , " ")+'</h4><span class="muted">'+scores.count+' '+plural+'</span></div><div class="grid__item two-fifths"><div class="relative" style="width: 80px; height: 80px; display: inline-block; margin-bottom: -5px;"><div class="pieWrapper"><div class="pie rightPie"></div><div class="pie leftPie" style="-webkit-transform: rotate('+Math.round(scores.avg*20*3.6)+'deg);"></div><div class="percentOverlay">'+Math.round(scores.avg*20)+'<small style="position: relative; top: -4px; left: 2px;">%</small></div></div></div></div></div></div><br /></div>');						
					}
				}
				$('#subratings').show();
				
			}
		
			if(rjson.hasOwnProperty('distribution')) {
				for(var key in rjson.distribution) {
					if(key != 'total') {
						var sd = $('#stars-'+key);
						sd.attr('data-count', rjson.distribution[key]);
						sd.find('.count:first').html('('+rjson.distribution[key]+')');
						sd.find('.bar:first').attr('style', 'width: '+(rjson.distribution[key] / rjson.distribution.total * 100) + '%');
					}
				}
			}
			
			if(rjson.hasOwnProperty('media') && Object.keys(rjson.media).length > 0) {
				var rimages = [];
				$.each(rjson.media, function(i, e) {
					if(Object.keys(rjson.media).length > 2) {
						rimages.push({
							'url': e.files[0],
							'id': e.id,
							'title': e.title
						});
					}
					else {
						$.each(e.files, function(ekey, url) {
							rimages.push({
								'url': url,
								'id': e.id,
								'title': e.title
							});
						});
					}
				});
				
				var $rmedia = $('#reviews-media');
				$.each(rimages, function(i, e) {
					$rmedia.append('<div class="media"><a href="#" class="review-media" data-id="'+e.id+'" title="'+e.title.replace(/"/g, '&quot;')+'"><img src="//www.smokecartel.com/cdn/shop/t/38/assets/b.gif?v=111003715552405036781733865278" data-src="https://smokecartelapi.imgix.net/reviews/'+e.url+'?format=auto&w=200&h=200&crop=edges&fit=crop" alt="" class="lazyload" /></a></div>');
				});
				$rmedia.show();
				
				$('#reviews-media a.review-media').click(function(event) {
					event.preventDefault();
					var pid = $('#AddToCartForm').data('pid');
					var rid = $(this).data('id');
					$.get('//api.smokecartel.com/reviews/fetch.php?pid='+pid+'&reviews=1&id='+rid+'&format=html', function(resp) {		
						$('#reviews-load').html(resp);
						$('#reviews-detail').show();
					});
				});
			}
			
			if($('.product-reviews-content').find('.review').length > 0) {
				if($('#reviews-paginate').length > 0) {
					var prevbtn = $('#reviews-paginate').find('span.prev:first');
					var nextbtn = $('#reviews-paginate').find('span.next:first');
					var offset = 40;
					if(ismobile) { offset = 80; }
					$('#reviews-paginate').find('a.review-paginate').click(function(event) {
						if(!$(this).parent().hasClass('current')) {
							var pt = $(this).text();
							if(pt == 'Next ') {
								var tb = $('#reviews-paginate').find('span.current').next();
								if(tb.text() != 'Next ') {
									tb.find('a:first').trigger('click');
								}
							}
							else if(pt == ' Previous') {
								var tb = $('#reviews-paginate').find('span.current').prev();
								if(tb.text() != ' Previous') {
									tb.find('a:first').trigger('click');
								}
							}
							else {
								$('.product-reviews-content').find('.review').hide();
								$('.product-reviews-content').find('.review.page-'+pt).fadeIn(300);
								$('#reviews-paginate').find('span.page.current').removeClass('current');
								$(this).parent().addClass('current');
								$('html, body').animate({
				                    scrollTop: $(".product-reviews-content").offset().top - offset
				                }, 200);
								
								if(pt > 1) { prevbtn.show(); }
								else { prevbtn.hide(); }
								
								if(pt == $('#paging').find('span.last').text()) { nextbtn.hide(); }
								else { nextbtn.show(); }
							}
						}
						event.preventDefault();
						return false;
					});
				}
				
				$('#reviews-breakdown').find('a.filterbyrating').click(function(event) {
					var scoretarget = $(this).data('score');
					var pid = $('#AddToCartForm').data('pid');
					
					$.getJSON('//api.smokecartel.com/reviews/fetch.php?pid='+pid+'&reviews=150&filter_score='+scoretarget, function(resp) {
						console.log(resp);
					});
				});
				
				$('#reviews-breakdown').find('a.filterbyrating').click(function(event) {
					event.preventDefault();
					
					var count = $(this).parent().data('count');
					if(count > 0) {
						var scoretarget = $(this).data('score');
						var pid = $('#AddToCartForm').data('pid');
						
						$('#review-low-score').hide();
						$.get('//api.smokecartel.com/reviews/fetch.php?pid='+pid+'&reviews=150&filter_score='+scoretarget+'&format=html', function(resp) {		
							$('#reviews-load').html(resp);
							if(scoretarget <= 3) {
								$('#review-low-score').show();
							}
							$('#reviews-detail').show();
						});
					}
					
					return false;
				});
				
				$('#load-all-reviews').click(function(event) {
					event.preventDefault();
					var pid = $('#AddToCartForm').data('pid');
					$.get('//api.smokecartel.com/reviews/fetch.php?pid='+pid+'&reviews=1000&format=html', function(resp) {		
						$('#reviews-load').html(resp);
						$('#reviews-detail').show();
					});
				});
					
				
				
				$('.product-reviews-content').find('a.vote-review').click(function(event) {
					var vc = $(this).parent();
					$.post( "//api.smokecartel.com/reviews/vote.php", { rid: $(this).parent().data('rid'), value: $(this).data('value') }, function( data ) {
						if(data == 'success') { vc.html('<span class="green">Thank you for your vote!</span>'); }
						else { alert(data); }
					});
					event.preventDefault();
					return false;
				});
				
				
			}
		}
    }).fail(function() { 
	    $('#reviews-data').html('<p class="muted">No reviews on this product yet!</p>');
    });
}

function loadProductModal(href, vid, elem) {
	var handle = href.split('/');
	handle = handle[handle.length - 1];
		
	var target = $('#addon-product-info').find('.content');
	
	Shopify.getProductFull(handle, function(product) {		
		var foundwhiteimg = false;
		var imgsrc = Shopify.resizeImage(product.image.src, 'medium');
		$.each(product.images, function(i, img) {
			if(img.alt !== null && img.alt.includes('[WHITE]') && !foundwhiteimg) {
				imgsrc = Shopify.resizeImage(img.src, 'medium');
				foundwhiteimg = true;
			}
		});
		
		var vtitle = '';
		if(vid != '') {
			// Find variant
			$.each(product.variants, function(i, v) {
				if(v.id == vid && v.featured_image) {
					imgsrc = Shopify.resizeImage(v.featured_image.src, 'medium');
				}
				if(v.id == vid && v.title != 'Default Title') {
					vtitle = v.title;
				}
			});
		}
		target.find('img:first').attr('src', imgsrc);
		
		target.find('h4').html(product.title);
		target.find('h5').html('');
		if(vtitle != '') {
			target.find('h5').html(vtitle);
		}
		
		target.find('.description').html(product.body_html);
		target.find('.product-addon-action').html('<br /><p><a href="#" class="btn" id="add-addon-item-btn">Add Item to Cart</a> <a href="/products/'+product.handle+'" target="_blank" class="btn--muted"><i class="icon-right-open"></i> View Product</a></p><p class="mobile"><a href="#" onclick="$(\'#addon-product-info\').hide(); return false;" class="btn--muted"><i class="icon-cancel"></i> Close</a></p>');
		
		target.find('a#add-addon-item-btn').click(function(event) {
			event.preventDefault();
			elem.parentsUntil('.addon-container').parent().find('input[type="checkbox"]').prop('checked', true);
			target.parent().hide();
			return false;
		});
		
		target.parent().show();		
	});
}

window['activateTabs'] = function() {
	var $scroll_ul = $('#scroll-top-widget ul');
    $('[data-tab]').each(function(i,e) {
	    $scroll_ul.append('<li><a href="#'+$(this).attr('id')+'">'+$(this).data('tab')+'</a></li>')
    });
    animateScroll();
    
    $scroll_ul.find('li > a').each(function(i,e) {
	   $($(this).attr('href')).waypoint({
		   	handler: function(direction) {
			   	if(this.element.id == 'product-description') {
				   	if(direction == 'down') {
				   		$('#scroll-top-widget').addClass('fixed');
				   	}
				   	else {
					   	$('#scroll-top-widget').removeClass('fixed');
				   	}
			   	}
			   	else if(this.element.id == 'product-top') {
					$('#scroll-top-widget').removeClass('fixed');
				}
			   	$scroll_ul.find('a').removeClass('active');
			   	$scroll_ul.find('a[href="#'+this.element.id+'"]').addClass('active');
			   	
			   	// Scroll to element
			   	$scroll_ul.scrollTo($scroll_ul.find('a.active'), 300);
			}
		}, { offset: 100 });
    });
}

function activatePreference() {
	// Preference
	if(!ismobile) {
		$('#logocolor').keyup(function() {
			if(this.value) { $('#more-color-options').show(); }
			else { $('#more-color-options').hide(); $(this).parent().hide(); $(this).parent().parent().find('.edit-preference:first').show(); }
		});
	}
	$('#logocolor').bind('focusin focus', function(e){
		e.preventDefault();
	});

	$('.edit-preference').click(function(event) {
		$(this).hide().parent().find('.input-preference').attr('style','display: inline-block;');
		$('.manual-color-options').show();
		event.preventDefault();
		return false;
	});
	
	$('.manual-color-options button').click(function(event) {		
		if($(this).hasClass('active')) {
			// Remove option
			$(this).removeClass('active');
		}
		else {
			$(this).addClass('active');
		}
		
		var values = [];
		$('.manual-color-options button.active').each(function(i,e) {
			values.push($(e).val());
		});
		$('#color-choices').val(values.join(', '));
		
		event.preventDefault();
		return false;
	});
}

function parsePD(data, product, vendorcid) {	
	if((data.lastsync + 21600) < Math.floor(Date.now() / 1000)) {
		sendBeacon(); 
	}
					
	// Similar
	if(data.hasOwnProperty('similar') && data.similar.length > 4) {
		var sscroller = $('#similarproducts-scroller');
		sscroller.html('');
		$.each(data.similar, function(i, e) {
			renderScroller(i, e, sscroller);
		});
	}
	else {
		$('#similarproducts').remove();
	}
	
	// Also Viewed			
	if(data.hasOwnProperty('alsoviewed') && data.alsoviewed.length > 4) {
		var sscroller = $('.alsoviewed-scroller');
		sscroller.html('');
		$.each(data.alsoviewed, function(i, e) {
			renderScroller(i, e, sscroller);
		});
	}
	else {
		$('.alsoviewed').remove();
	}
	
 
	// Related Articles			
	if(data.hasOwnProperty('articles')) {
		var atarget = $('#related_articles');
		if(data.articles.length > 0) {
			$.each(data.articles, function(i, e) {
			atarget.append('<div class="grid__item large--one-half"><p><a href="//www.smokecartel.com/pages/'+e.handle+'"><img src="//www.smokecartel.com/cdn/shop/t/38/assets/b.gif?v=111003715552405036781733865278" data-src="'+e.img.replace('http://','https://').replace('.jp', '_545x.jp')+'" class="lazyload" alt="'+e.title.replace('"', '')+'" /></a></p><p>'+e.text+'</p><p><a href="//www.smokecartel.com/pages/'+e.handle+'" class="btn--muted">Continue Reading</a></p><br /></div>');
			});
		}
		else {
			atarget.parent().remove();
		}
	}
	
}

window['loadProductRecs'] = function() {
	console.log('Loading product recs');
	var scrollertarget = $('#product-recs-scroller');
	var $product_recs = $('#product-recs');
	$product_recs.removeClass('persistant');

	
	
	function getAlsoViewed() {
		scrollertarget.html('loading.....');
		$.getJSON("//warely.io/apps/recommendations/beta.php?handle="+productjson.handle+"&limit=16&scenario=product_related&type=items-to-item&cart="+encodeURIComponent(current_cart), function(products) {	
			scrollertarget.html('');
			
			if(products.length > 4) {
				$.each(products, function(i, e) {
					renderScroller_new(i, e, scrollertarget);
				});
				
				activateSlider();
				activateVideo(ismobile);
			}
			// else {
			// 	// $product_recs.find('.slider-pill-nav a[data-load="also-viewed"]').remove();
			// 	$product_recs.find('.slider-pill-nav a[data-load="similar"]').trigger('click');
			// }
		});
	}
	
	function getUserRecs(scrollertarget, current_cart) {
		// Try to get recommendations for user instead 
		console.log(current_cart)
		getToken(function(carttoken) {
			let product_ids = ShopifyCart.items.map(item => item.product_id).join(',')
			// console.log(product_ids) 
			// +encodeURIComponent(current_cart)
			$.getJSON("//warely.io/apps/recommendations/beta.php?cart_token="+carttoken+"&limit=16&scenario=added_to_cart&type=items-to-user&cart="+current_cart, function(products) {
				scrollertarget.html('');
					
				$.each(products, function(i, e) {
					renderScroller_new(i, e, scrollertarget);
				});
				
				activateSlider();
				activateVideo(ismobile);
			});


			// const url = "https://warely.io/apps/recommendations/beta.php";
			// const data = {
			// 	"cart_token": carttoken,
			// 	"limit": "16",
			// 	"scenario": "added_to_cart",
			// 	"type": "items-to-user",
			// 	"cart":JSON.stringify(ShopifyCart)
			// };

			// fetch(url, {
			// 	method: "POST",
			// 	// headers: {
			// 	// 'Content-Type': 'application/json',
			// 	// },
			// 	body: JSON.stringify(data)
			// })
			// .then(response => response.json())
			// .then(data => console.log(data))
			// .catch(error => console.error("Error:", error));


		});
	}
	
	function getReplacementParts(scrollertarget, handle,details = null) {
		$.get('/collections/all/master_product:'+handle+'?view=load-slider', function(html) {
			scrollertarget.html('');
			var $html = $.parseHTML(html);
			
			$.each($html, function(j, c) {
                
				if(c.nodeName == 'DIV' && $(c).attr('id') == 'scroller-content') {
					scrollertarget.prepend($(c).contents());
					activateSlider();
					activateVideo(ismobile);		
				}

				if(details != null) {
					setTimeout(function() {
						callGTMSlider(html,details)
					},1000)
				}
				
			});	
		});
	}
	
	// Check if has upgrades, etc
	if($('#product-recs .slider-pill-nav a[data-load="similar"]').length > 0) {
		$.get('/collections/'+$('#product-recs .slider-pill-nav a[data-load="similar"]').attr('data-collection')+'?view=load-slider', function(html) {
			scrollertarget.html('');
			var $html = $.parseHTML(html);
			var details = $('#product-recs .slider-pill-nav a[data-load="similar"]').attr('data-details');
			$.each($html, function(j, c) {
				if(c.nodeName == 'DIV' && $(c).attr('id') == 'scroller-content') {
					scrollertarget.prepend($(c).contents());
					
					activateSlider();
					activateVideo(ismobile);		
				}
				$('#product-recs .slider-pill-nav a[data-load="similar"]').addClass('active');
			});	
			setTimeout(function() {
				callGTMSlider(html,details)
			},1000)		
		});
	}
	else {
		getAlsoViewed();
	}
	
	$('#product-recs .slider-pill-nav a').click(function(event) {
		event.preventDefault();
		
		if(!$(this).hasClass('active')) {	
			$(this).parent().find('.active').removeClass('active');
			$(this).addClass('active');
			
			var tab_load = $(this).attr('data-load');
			var details = $(this).attr('data-details');
			if(tab_load == 'also-viewed') {
				getAlsoViewed();
			}
			else if(tab_load == 'similar') {
				// Try using search to find related products
				$.get('/collections/'+$(this).attr('data-collection')+'?view=load-slider', function(html) {
					scrollertarget.html('');
					var $html = $.parseHTML(html);
					$.each($html, function(j, c) {
						if(c.nodeName == 'DIV' && $(c).attr('id') == 'scroller-content') {
							scrollertarget.prepend($(c).contents());
							
							activateSlider();
							activateVideo(ismobile);		
						}
					});		
					
					setTimeout(function() {
						callGTMSlider(html,details)
					},1000)
				});
				
 
			}
			else if(tab_load == 'also-bought') {
				$.getJSON("//warely.io/apps/recommendations/beta.php?handle="+productjson.handle+"&limit=16&scenario=related_by_order&type=items-to-item&cart="+encodeURIComponent(current_cart), function(products) {
					scrollertarget.html('');
					if(products.length > 4) {
						$.each(products, function(i, e) {
							renderScroller_new(i, e, scrollertarget);
						});
						
						activateSlider();
						activateVideo(ismobile);
					}
					else {
						$product_recs.find('.slider-pill-nav a[data-load="also-bought"]').remove();
						$product_recs.find('.slider-pill-nav a[data-load="similar"]').trigger('click');
					}
				});
			}
			else if(tab_load == 'vendor') {
				$.get('/collections/'+$(this).attr('data-vendor')+'?view=load-slider', function(html) {
					scrollertarget.html('');
					var $html = $.parseHTML(html);
					$.each($html, function(j, c) {
						if(c.nodeName == 'DIV' && $(c).attr('id') == 'scroller-content') {
							scrollertarget.prepend($(c).contents());
							
							activateSlider();
							activateVideo(ismobile);		
						}
					});	
					setTimeout(function() {
						callGTMSlider(html,details)
					},1000)		
				});
			}
			else if(tab_load == 'upgrades') {  
				// getReplacementParts(scrollertarget, productjson.handle,details);
				$.get('/collections/all/master_product:'+productjson.handle+'?view=load-slider', function(html) {
					scrollertarget.html('');
					var $html = $.parseHTML(html);
					
					$.each($html, function(j, c) {
						
						if(c.nodeName == 'DIV' && $(c).attr('id') == 'scroller-content') {
							scrollertarget.prepend($(c).contents());
							activateSlider();
							activateVideo(ismobile);		
						} 
					});	

					if(details != null) {
						setTimeout(function() {
							callGTMSlider(html,details)
						},1000)
					}
				});
			}

				
		}

		// window.dataLayer = window.dataLayer || [];
		// 		window.dataLayer.push({ ecommerce: null });
		// 		console.log('function loaded')
				
		// 		$('body .slide-container').on('click', function(e) {
		// 			console.log('clicked grid')
		// 			let productId = $(this).data('pid');
		// 			let productScript = JSON.parse($('#new_event_' + productId).html());


		// 			console.log(productScript);
		// 			window.dataLayer = window.dataLayer || [];
		// 			window.dataLayer.push({
		// 				'event': 'select_item',
		// 				'ecommerce': {
		// 				'items': [productScript]
		// 				}
		// 			});
		// 		}); 
	});
}


function formatMoney(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\s*(\w+)\s*\}/;
  var formatString = (format || '$');

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
}
 